



























































































































































































































































import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import Vue from 'vue';
import ref from 'vue';
import { Resolve } from 'vue-di';
import { Component, Watch } from 'vue-property-decorator';
import Footer from '~/components/common/Footer/Footer.vue';
import Header from '~/components/common/Header/Header.vue';
import theme from '~/settings/theme';
import LayoutModule from '~/store/layout';
import SectionModule from '~/store/section';
import SessionModule from '~/store/session';

@Component<DefaultLayout>({
    components: {
        Header,
        Footer,
    },
    mounted() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((this as any).$meta) (this as any).$meta().refresh();
        const anySelection = this.sectionStore.anyPathSelected;
        if (!anySelection) {
            this.$router.push('/');
        }
        // Added event listener to check window resizing
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    icons: {
        faArrowRight
    },
})
export default class DefaultLayout extends Vue {

    @Resolve
    public session!: SessionModule;

    @Resolve
    public layout!: LayoutModule;

    @Resolve
    sectionStore!: SectionModule;

    created() {
        if (!this.sectionStore.activeUniqueMenuItems) {
            this.sectionStore.resetSelections()
            this.$router.push('/')
        }
    }

    @Watch('this.$route.query', { immediate: true })
    setTestPdf() {
        const testPDF = !!this.$route.query.testPDF && this.$route.query.testPDF === 'true';
        this.layout.setShowTestPDF(testPDF);
    }

    public isTablet = false;

    handleResize() {
        const isTabletNow = window.innerWidth <= 960;
        if (isTabletNow !== this.isTablet) {
            this.isTablet = isTabletNow;
            // Performing state change here only once when it resized from desktop to tablet
            if (this.isTablet) {
                this.layout.setDrawer(false);
            }
        }
    }

    public theme = theme;

    activeMenuItems = this.sectionStore.activeUniqueMenuItems;

    // Allows user to close the configuration drawer by hitting escape
    public get drawerItems() {
        return this.layout.drawerNavigation;
    }

    public get drawer() {
        return this.layout.drawer;
    }

    public set drawer(v) {
        this.layout.setDrawer(v);
    }

    public currentPath(route: string) {
        if (this.$route.path.endsWith('/') && !route.endsWith('/')) {
            return this.$route.path === route + '/';
        } else if (!this.$route.path.endsWith('/') && route.endsWith('/')) {
            return this.$route.path === route.slice(0, -1);
        } else {
            return this.$route.path === route;
        }
    }

    public moveTo(url: string) {
        this.$router.push(url)
    }

    public get brkPoints() {
        return {
            'brk-xs': this.$vuetify.breakpoint.xs,
            'brk-xs-only': this.$vuetify.breakpoint.xsOnly,
            'brk-sm': this.$vuetify.breakpoint.sm,
            'brk-sm-only': this.$vuetify.breakpoint.smOnly,
            'brk-sm-and-down': this.$vuetify.breakpoint.smAndDown,
            'brk-sm-and-up': this.$vuetify.breakpoint.smAndUp,
            'brk-md': this.$vuetify.breakpoint.md,
            'brk-md-only': this.$vuetify.breakpoint.mdOnly,
            'brk-md-and-down': this.$vuetify.breakpoint.mdAndDown,
            'brk-md-and-up': this.$vuetify.breakpoint.mdAndUp,
            'brk-lg': this.$vuetify.breakpoint.lg,
            'brk-lg-only': this.$vuetify.breakpoint.lgOnly,
            'brk-lg-and-down': this.$vuetify.breakpoint.lgAndDown,
            'brk-lg-and-up': this.$vuetify.breakpoint.lgAndUp,
            'brk-xl': this.$vuetify.breakpoint.xl,
            'brk-xl-only': this.$vuetify.breakpoint.xlOnly,
        };
    }
}
